<template>
    <div class="columns is-centered">
        <div class="column is-6">
            <form @submit.prevent="submit">
                <h4 class="title is-4">
                    Register
                </h4>

                <p class="subtitle">
                    Enter your details to register with {{ $meta.themeName }}.
                </p>

                <FormNotification />

                <SavingNotification>
                    Sending...
                </SavingNotification>

                <b-field label="Title">
                    <b-input
                        v-model="Title"
                        v-validate="{ required: true, max: 10 }"
                        name="Title"
                    />
                </b-field>

                <div class="columns">
                    <div class="column">
                        <b-field label="First Name">
                            <b-input
                                v-model="FirstName"
                                v-validate="{ required: true, max: 50 }"
                                name="First Name"
                            />
                        </b-field>
                    </div>

                    <div class="column">
                        <b-field label="Surname">
                            <b-input
                                v-model="Surname"
                                v-validate="{ required: true, max: 50 }"
                                name="Surname"
                            />
                        </b-field>
                    </div>
                </div>

                <b-field label="Email">
                    <b-input
                        v-model="Email"
                        v-validate="{ required: true, email: true }"
                        type="email"
                        name="Email"
                    />
                </b-field>

                <div class="columns">
                    <div class="column">
                        <b-field label="Phone (daytime)">
                            <b-input
                                v-model="PhoneDay"
                                v-validate="{ required: true, max: 20 }"
                                name="Phone (daytime)"
                            />
                        </b-field>
                    </div>

                    <div class="column">
                        <b-field label="Phone (evening)">
                            <b-input
                                v-model="PhoneEvening"
                                v-validate="{ required: true, max: 20 }"
                                name="Phone (evening)"
                            />
                        </b-field>
                    </div>
                </div>

                <hr class="mb-1" />

                <div class="columns">
                    <div class="column is-4">
                        <b-button
                            type="is-info"
                            tag="button"
                            :disabled="isSending || isSuccess"
                            native-type="submit"
                        >
                            Submit
                        </b-button>
                    </div>

                    <div class="column is-9">
                        <p class="has-text-grey has-text-right-desktop">
                            <small>
                                Visit the
                                <a
                                    :href="$meta.website_url"
                                    :title="`Visit ${$meta.themeName}`"
                                    target="_blank"
                                >Agent's website</a>
                                for their data processing policy.
                            </small>
                        </p>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import Form from '../../mixins/form.js';

export default {
    mixins: [
        Form,
    ],

    computed: {
        ...mapFields('lead', [
            'lead.Title',
            'lead.FirstName',
            'lead.Surname',
            'lead.Email',
            'lead.PhoneDay',
            'lead.PhoneEvening',
        ]),
    },

    mounted() {
        // pass property id
        this.$store.dispatch('lead/setPropertyIdentifier', this.$route.params.id);
    },

    methods: {
        submit() {
            this.isSuccess = null;

            this.validate()
                .then((result) => {
                    if (! result) {
                        return;
                    }

                    this.$store.dispatch('lead/register')
                    .then((response) => {
                        this.statusMessage = response.data.message;
                        this.statusType = 'success';
                        this.isSuccess = true;
                        this.isSending = false;
                    })
                    .catch((error) => {
                        this.parseServerErrors(error);
                        this.isSuccess = false;
                        this.isSending = false;
                    });
                });
        },
    },
};
</script>
